import { Dispatch, SetStateAction } from "react";
import './pager.scss';

function PagerView({
    elements, 
    page, 
    setPage, 
    numberOfResults
} : {
    elements: any[],
    page: number,
    setPage: Dispatch<SetStateAction<number>>,
    numberOfResults: number
}) {
    return (
        <div id="pager">
            {page > 1 ? <i className="fal fa-angle-left" onClick={() => setPage(--page)}></i> : <i className="fal fa-angle-left disabled"></i>}
            <div id="paging-numbers">
                {page > 3 && page > Math.floor(elements.length / numberOfResults) ? <span onClick={() => setPage(page - 4)}>{page - 4}</span> : ''}
                {page > 2 && page > Math.floor(elements.length / numberOfResults - 1) ? <span onClick={() => setPage(page - 3)}>{page - 3}</span> : ''}
                {page > 2 ? <span onClick={() => setPage(page - 2)}>{page - 2}</span> : ''}
                {page >= 2 ? <span onClick={() => setPage(page - 1)}>{page - 1}</span> : ''}
                <span className="active">{page}</span>
                {page <= Math.floor(elements.length / numberOfResults) ? <span onClick={() => setPage(page + 1)}>{page + 1}</span> : ''}
                {page < Math.floor(elements.length / numberOfResults) ? <span onClick={() => setPage(page + 2)}>{page + 2}</span> : ''}
                {elements.length > numberOfResults * 2 && page < 3 ? <span onClick={() => setPage(page + 3)}>{page + 3}</span> : ''}
                {elements.length > numberOfResults * 2 && page < 2 ? <span onClick={() => setPage(page + 4)}>{page + 4}</span> : ''}
            </div>
            {page <= Math.floor(elements.length / numberOfResults) ? <i className="fal fa-angle-right" onClick={() => setPage(++page)}></i> : <i className="fal fa-angle-right disabled"></i>}
        </div>
    )
}

export default PagerView;